<template>
  <v-container fluid class="container-with-scroll">
    <div class="exclusao-ordens-container">
      <!-- ✅ HEADER DA PÁGINA -->
      <div class="page-header">
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-avatar size="48" color="red-darken-1" class="mr-4">
              <v-icon color="white" size="28">mdi-delete-outline</v-icon>
            </v-avatar>
            <div>
              <h1 class="text-h4 font-weight-bold text-red-darken-1">Exclusão de Ordens</h1>
            </div>
          </div>
          <v-btn
            color="grey"
            variant="outlined"
            @click="voltaraomenu"
            class="back-btn"
          >
            <v-icon start>mdi-arrow-left</v-icon>
            Voltar ao Menu
          </v-btn>
        </div>
      </div>

      <!-- ✅ ABAS PRINCIPAIS -->
      <v-card class="main-card" elevation="2">
        <v-tabs 
          v-model="activeTab" 
          color="red-darken-1" 
          align-tabs="center"
          class="tabs-header"
        >
          <v-tab value="exclusao" class="tab-item">
            <v-icon start>mdi-delete-outline</v-icon>
            Excluir Ordem
          </v-tab>
          <v-tab value="historico" class="tab-item">
            <v-icon start>mdi-history</v-icon>
            Histórico
            <v-chip 
              v-if="totalLogsExclusao > 0" 
              size="small" 
              color="red-darken-1" 
              class="ml-2"
            >
              {{ totalLogsExclusao }}
            </v-chip>
          </v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <!-- ✅ CONTEÚDO DAS ABAS -->
        <v-window v-model="activeTab" class="tabs-content">
          
          <!-- ========================================
               ABA 1: EXCLUSÃO DE ORDEM
          ======================================== -->
          <v-window-item value="exclusao" class="pa-6">
            <div class="exclusao-section">
              <!-- Busca de Ordem -->
              <v-card class="search-card mb-6" variant="outlined">
                <v-card-title class="bg-red-lighten-5 pa-4">
                  <v-icon class="mr-2" color="red-darken-1">mdi-magnify</v-icon>
                  Buscar Ordem para Exclusão
                </v-card-title>
                
                <v-card-text class="pa-4">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="buscaOrdemId"
                        label="ID da Ordem"
                        placeholder="Digite o ID da ordem..."
                        variant="outlined"
                        prepend-inner-icon="mdi-identifier"
                        clearable
                        :loading="carregandoDetalhes"
                        @keyup.enter="buscarDetalhesOrdem"
                        @input="limparDetalhes"
                      >
                        <template v-slot:append>
                          <v-btn
                            color="red-darken-1"
                            variant="flat"
                            @click="buscarDetalhesOrdem"
                            :loading="carregandoDetalhes"
                            :disabled="!buscaOrdemId"
                          >
                            <v-icon start>mdi-magnify</v-icon>
                            Buscar
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="6">
                      <v-alert 
                        type="warning" 
                        variant="tonal" 
                        density="compact"
                        class="mb-0"
                      >
                        <v-icon start>mdi-information</v-icon>
                        Digite o ID da ordem que deseja excluir
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Detalhes da Ordem (quando encontrada) -->
              <div v-if="detalhesOrdem" class="detalhes-section">
                <v-card class="detalhes-card mb-4" variant="outlined">
                  <v-card-title class="bg-blue-lighten-5 pa-4">
                    <v-icon class="mr-2" color="blue-darken-1">mdi-information-outline</v-icon>
                    Detalhes da Ordem {{ detalhesOrdem.ordem.id }}
                  </v-card-title>
                  
                  <v-card-text class="pa-4">
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="info-item mb-3">
                          <div class="text-caption text-grey">Cliente</div>
                          <div class="text-h6">{{ detalhesOrdem.ordem.cliente?.nome || 'N/A' }}</div>
                        </div>
                        <div class="info-item mb-3">
                          <div class="text-caption text-grey">Número do Pedido</div>
                          <div class="text-h6">{{ detalhesOrdem.ordem.numero_pedido || 'N/A' }}</div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="info-item mb-3">
                          <div class="text-caption text-grey">Data de Lançamento</div>
                          <div class="text-h6">{{ formatarData(detalhesOrdem.ordem.data_lancamento) }}</div>
                        </div>
                        <div class="info-item mb-3">
                          <div class="text-caption text-grey">Previsão de Entrega</div>
                          <div class="text-h6">{{ formatarData(detalhesOrdem.ordem.previsao_entrega) }}</div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Registros que serão excluídos -->
                <v-card class="registros-card mb-4" variant="outlined">
                  <v-card-title class="bg-warning-lighten-5 pa-4">
                    <v-icon class="mr-2" color="warning-darken-1">mdi-alert-circle</v-icon>
                    Registros que serão EXCLUÍDOS
                  </v-card-title>
                  
                  <v-card-text class="pa-4">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-card class="registro-item" variant="tonal" color="warning">
                          <v-card-text class="text-center pa-3">
                            <v-icon size="32" color="warning-darken-1">mdi-account-check</v-icon>
                            <div class="text-h5 font-weight-bold mt-2">
                              {{ detalhesOrdem.relacionados.liberacoes }}
                            </div>
                            <div class="text-caption">Liberações de Funcionário</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      
                      <v-col cols="12" md="4">
                        <v-card class="registro-item" variant="tonal" color="warning">
                          <v-card-text class="text-center pa-3">
                            <v-icon size="32" color="warning-darken-1">mdi-swap-horizontal</v-icon>
                            <div class="text-h5 font-weight-bold mt-2">
                              {{ detalhesOrdem.relacionados.movimentacoes }}
                            </div>
                            <div class="text-caption">Movimentações de Produção</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      
                      <v-col cols="12" md="4">
                        <v-card class="registro-item" variant="tonal" color="warning">
                          <v-card-text class="text-center pa-3">
                            <v-icon size="32" color="warning-darken-1">mdi-puzzle</v-icon>
                            <div class="text-h5 font-weight-bold mt-2">
                              {{ detalhesOrdem.relacionados.partes }}
                            </div>
                            <div class="text-caption">Partes da Ordem</div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    
                    <v-divider class="my-4"></v-divider>
                    
                    <div class="text-center">
                      <v-chip color="error" size="large" variant="elevated">
                        <v-icon start>mdi-sigma</v-icon>
                        Total: {{ totalRegistrosExclusao }} registros serão excluídos
                      </v-chip>
                    </div>
                  </v-card-text>
                </v-card>

                <!-- Campo de Observação -->
                <v-card class="observacao-card mb-6" variant="outlined">
                  <v-card-title class="bg-red-lighten-5 pa-4">
                    <v-icon class="mr-2" color="red-darken-1">mdi-pencil</v-icon>
                    Observação Obrigatória
                  </v-card-title>
                  
                  <v-card-text class="pa-4">
                    <v-textarea
                      v-model="observacaoExclusao"
                      label="Motivo da exclusão"
                      placeholder="Descreva detalhadamente o motivo da exclusão desta ordem (mínimo 10 caracteres)"
                      variant="outlined"
                      rows="4"
                      counter="500"
                      :rules="observacaoRules"
                      :error="!!observacaoError"
                      :error-messages="observacaoError"
                      required
                    ></v-textarea>
                    
                    <v-alert type="info" variant="tonal" density="compact" class="mt-3">
                      <v-icon start>mdi-information</v-icon>
                      Esta observação será registrada no log de auditoria e não poderá ser alterada
                    </v-alert>
                  </v-card-text>
                </v-card>

                <!-- ✅ BOTÕES DE AÇÃO - CORRIGIDO -->
                <div class="acoes-section mb-8">
                  <v-card variant="outlined" class="acoes-card">
                    <v-card-text class="pa-6">
                      <div class="d-flex justify-center align-center flex-wrap gap-4">
                        <v-btn
                          color="grey"
                          variant="outlined"
                          size="large"
                          @click="limparTudo"
                          :disabled="excluindoOrdem"
                          class="action-btn"
                        >
                          <v-icon start>mdi-cancel</v-icon>
                          Cancelar
                        </v-btn>
                        
                        <v-btn
                          color="error"
                          variant="elevated"
                          size="large"
                          @click="confirmarExclusao"
                          :loading="excluindoOrdem"
                          :disabled="!podeExcluir"
                          class="action-btn excluir-btn"
                        >
                          <v-icon start>mdi-delete</v-icon>
                          EXCLUIR ORDEM
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>

              <!-- Estado vazio -->
              <div v-else-if="!carregandoDetalhes" class="empty-state text-center py-8">
                <v-avatar size="80" color="grey-lighten-3" class="mb-4">
                  <v-icon size="40" color="grey">mdi-magnify</v-icon>
                </v-avatar>
                <h3 class="text-h6 text-grey mb-2">Busque uma ordem para excluir</h3>
                <p class="text-grey">Digite o ID da ordem no campo acima para visualizar os detalhes</p>
              </div>
            </div>
          </v-window-item>

          <!-- ========================================
               ABA 2: HISTÓRICO DE EXCLUSÕES
          ======================================== -->
          <v-window-item value="historico" class="pa-6">
            <div class="historico-section">
              <!-- Filtros -->
              <v-card class="filtros-card mb-6" variant="outlined">
                <v-card-title class="bg-blue-lighten-5 pa-4">
                  <v-icon class="mr-2" color="blue-darken-1">mdi-filter</v-icon>
                  Filtros de Pesquisa
                </v-card-title>
                
                <v-card-text class="pa-4">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="filtrosHistorico.usuario"
                        label="Usuário"
                        placeholder="Nome do usuário..."
                        variant="outlined"
                        prepend-inner-icon="mdi-account"
                        clearable
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="filtrosHistorico.data_inicio"
                        label="Data Início"
                        type="date"
                        variant="outlined"
                        prepend-inner-icon="mdi-calendar"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="filtrosHistorico.data_fim"
                        label="Data Fim"
                        type="date"
                        variant="outlined"
                        prepend-inner-icon="mdi-calendar"
                      ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" md="2">
                      <v-btn
                        color="blue-darken-1"
                        variant="flat"
                        block
                        @click="buscarHistorico"
                        :loading="carregandoHistorico"
                      >
                        <v-icon start>mdi-magnify</v-icon>
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Tabela de Histórico -->
              <v-card variant="outlined" class="mb-8">
                <v-card-title class="bg-grey-lighten-5 pa-4">
                  <v-icon class="mr-2" color="grey-darken-1">mdi-table</v-icon>
                  Histórico de Exclusões
                  <v-spacer></v-spacer>
                  <v-chip color="primary" variant="tonal">
                    {{ totalLogsExclusao }} registros
                  </v-chip>
                </v-card-title>
                
                <v-data-table
                  :headers="headersHistorico"
                  :items="logsExclusao"
                  :loading="carregandoHistorico"
                  :items-per-page="10"
                  class="historico-table"
                  no-data-text="Nenhuma exclusão encontrada"
                  loading-text="Carregando histórico..."
                >
                  <template v-slot:item.data_exclusao="{ item }">
                    <div class="text-body-2">
                      {{ formatarDataHora(item.data_exclusao) }}
                    </div>
                  </template>
                  
                  <template v-slot:item.registros_excluidos="{ item }">
                    <v-chip color="warning" size="small">
                      {{ calcularTotalRegistros(item.registros_excluidos) }}
                    </v-chip>
                  </template>
                  
                  <template v-slot:item.observacao="{ item }">
                    <div class="observacao-cell">
                      {{ truncarTexto(item.observacao, 50) }}
                      <v-tooltip v-if="item.observacao && item.observacao.length > 50" activator="parent">
                        {{ item.observacao }}
                      </v-tooltip>
                    </div>
                  </template>
                  
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      color="primary"
                      @click="verDetalhesExclusao(item)"
                    >
                      <v-icon>mdi-eye</v-icon>
                      <v-tooltip activator="parent">Ver detalhes</v-tooltip>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </v-window-item>
        </v-window>
      </v-card>

      <!-- ✅ MODAL DE CONFIRMAÇÃO -->
      <v-dialog
        v-model="showConfirmDialog"
        max-width="600px"
        persistent
      >
        <v-card>
          <v-card-title class="bg-error text-white pa-4">
            <v-icon class="mr-2">mdi-alert-circle</v-icon>
            CONFIRMAR EXCLUSÃO
          </v-card-title>
          
          <v-card-text class="pa-6">
            <v-alert type="error" variant="tonal" class="mb-4">
              <v-icon start>mdi-warning</v-icon>
              <strong>ATENÇÃO:</strong> Esta ação é IRREVERSÍVEL!
            </v-alert>
            
            <p class="text-h6 mb-3">
              Você está prestes a excluir a ordem <strong>{{ detalhesOrdem?.ordem?.id }}</strong>
            </p>
            
            <p class="mb-3">
              Serão excluídos <strong>{{ totalRegistrosExclusao }} registros</strong> 
              do banco de dados de forma permanente.
            </p>
            
            <p class="text-body-2 text-grey">
              Digite <strong>"CONFIRMAR"</strong> para prosseguir:
            </p>
            
            <v-text-field
              v-model="confirmacaoTexto"
              placeholder="Digite CONFIRMAR"
              variant="outlined"
              class="mt-3"
            ></v-text-field>
          </v-card-text>
          
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              @click="showConfirmDialog = false"
              :disabled="excluindoOrdem"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="error"
              variant="elevated"
              @click="executarExclusao"
              :loading="excluindoOrdem"
              :disabled="confirmacaoTexto !== 'CONFIRMAR'"
            >
              <v-icon start>mdi-delete</v-icon>
              EXCLUIR DEFINITIVAMENTE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ✅ MODAL DE DETALHES DA EXCLUSÃO -->
      <v-dialog
        v-model="showDetalhesDialog"
        max-width="800px"
        scrollable
      >
        <v-card v-if="exclusaoSelecionada" class="detalhes-modal">
          <v-card-title class="bg-primary text-white pa-4">
            <v-icon class="mr-2">mdi-information</v-icon>
            Detalhes da Exclusão - Ordem {{ exclusaoSelecionada.id_ordem_excluida }}
          </v-card-title>
          
          <v-card-text class="pa-6">
            <v-row>
              <v-col cols="12" md="6">
                <div class="detail-item mb-3">
                  <div class="text-caption text-grey">Usuário</div>
                  <div class="text-h6">{{ exclusaoSelecionada.usuario }}</div>
                </div>
                <div class="detail-item mb-3">
                  <div class="text-caption text-grey">Data da Exclusão</div>
                  <div class="text-h6">{{ formatarDataHora(exclusaoSelecionada.data_exclusao) }}</div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="detail-item mb-3">
                  <div class="text-caption text-grey">IP do Usuário</div>
                  <div class="text-h6">{{ exclusaoSelecionada.ip_usuario || 'N/A' }}</div>
                </div>
                <div class="detail-item mb-3">
                  <div class="text-caption text-grey">Total de Registros</div>
                  <div class="text-h6">{{ calcularTotalRegistros(exclusaoSelecionada.registros_excluidos) }}</div>
                </div>
              </v-col>
            </v-row>
            
            <v-divider class="my-4"></v-divider>
            
            <div class="detail-item">
              <div class="text-caption text-grey mb-2">Observação</div>
              <v-card variant="outlined" class="scrollable-content">
                <v-card-text class="pa-3">
                  <pre v-if="exclusaoSelecionada.observacao" class="formatted-text">{{ formatarObservacao(exclusaoSelecionada.observacao) }}</pre>
                  <p v-else class="text-grey">Nenhuma observação disponível</p>
                </v-card-text>
              </v-card>
              
              <!-- Dados Completos -->
              <v-card variant="outlined" class="mt-4 scrollable-content">
                <v-card-title class="text-subtitle-2">Dados Completos</v-card-title>
                <v-card-text class="pa-3">
                  <pre v-if="exclusaoSelecionada.dados_completos" class="formatted-text">{{ formatarDadosCompletos(exclusaoSelecionada.dados_completos) }}</pre>
                  <p v-else class="text-grey">Nenhum dado disponível</p>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
          
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              variant="outlined"
              @click="showDetalhesDialog = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ✅ SNACKBAR DE NOTIFICAÇÕES -->
      <v-snackbar
        v-model="showSnackbar"
        :color="snackbarColor"
        :timeout="5000"
        location="top"
      >
        {{ snackbarMessage }}
        <template v-slot:actions>
          <v-btn variant="text" @click="showSnackbar = false">
            Fechar
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-container>
</template>



<script>
import producaoService from '@/services/producaoService'

export default {
  name: 'ExclusaoOrdens',
  
  data() {
    return {
      // Estados principais
      activeTab: 'exclusao',
      
      // Estados da busca e exclusão
      buscaOrdemId: '',
      detalhesOrdem: null,
      observacaoExclusao: '',
      carregandoDetalhes: false,
      excluindoOrdem: false,
      
      // Estados do histórico
      logsExclusao: [],
      carregandoHistorico: false,
      totalLogsExclusao: 0,
      filtrosHistorico: {
        usuario: '',
        data_inicio: '',
        data_fim: ''
      },
      
      // Estados dos modais
      showConfirmDialog: false,
      showDetalhesDialog: false,
      confirmacaoTexto: '',
      exclusaoSelecionada: null,
      
      // Estados de notificação
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      
      // Configurações
      observacaoRules: [
        v => !!v || 'Observação é obrigatória',
        v => (v && v.length >= 10) || 'Observação deve ter pelo menos 10 caracteres',
        v => (v && v.length <= 500) || 'Observação deve ter no máximo 500 caracteres'
      ],
      
      headersHistorico: [
        { title: 'ID Ordem', key: 'id_ordem_excluida', sortable: true },
        { title: 'Usuário', key: 'usuario', sortable: true },
        { title: 'Data/Hora', key: 'data_exclusao', sortable: true },
        { title: 'Registros', key: 'registros_excluidos', sortable: false },
        { title: 'Observação', key: 'observacao', sortable: false },
        { title: 'Ações', key: 'actions', sortable: false, width: '100px' }
      ]
    }
  },
  
  computed: {
    observacaoError() {
      if (!this.observacaoExclusao) return null
      const rule = this.observacaoRules.find(rule => rule(this.observacaoExclusao) !== true)
      return rule ? rule(this.observacaoExclusao) : null
    },
    
    podeExcluir() {
      return this.detalhesOrdem && 
             this.observacaoExclusao && 
             this.observacaoExclusao.length >= 10 && 
             this.observacaoExclusao.length <= 500 &&
             !this.excluindoOrdem
    },
    
    totalRegistrosExclusao() {
      if (!this.detalhesOrdem?.relacionados) return 0
      return this.detalhesOrdem.relacionados.total + 1
    }
  },
  
  mounted() {
    this.buscarHistorico()
  },
  
  methods: {
    voltaraomenu() {
      this.$router.push({ name: "MenuDefault" }).catch(() => {});
    },
    // ========================================
    // MÉTODOS PRINCIPAIS
    // ========================================
    
    async buscarDetalhesOrdem() {
      if (!this.buscaOrdemId) {
        this.mostrarNotificacao('Digite o ID da ordem', 'warning')
        return
      }
      
      this.carregandoDetalhes = true
      
      try {
        const response = await producaoService.buscarDetalhesParaExclusao(this.buscaOrdemId)
        
        if (response.status === 'sucesso') {
          this.detalhesOrdem = response.data
          this.mostrarNotificacao('Ordem encontrada com sucesso', 'success')
        } else {
          throw new Error(response.message || 'Ordem não encontrada')
        }
      } catch (error) {
        console.error('Erro ao buscar ordem:', error)
        this.mostrarNotificacao(error.message || 'Erro ao buscar ordem', 'error')
        this.detalhesOrdem = null
      } finally {
        this.carregandoDetalhes = false
      }
    },
    
    confirmarExclusao() {
      if (!this.podeExcluir) return
      
      this.confirmacaoTexto = ''
      this.showConfirmDialog = true
    },
    
    async executarExclusao() {
      if (this.confirmacaoTexto !== 'CONFIRMAR') return
      
      this.excluindoOrdem = true
      
      try {
        const response = await producaoService.excluirOrdemCompleta(
          this.detalhesOrdem.ordem.id,
          this.observacaoExclusao
        )
        
        if (response.status === 'sucesso') {
          this.mostrarNotificacao(
            `Ordem ${response.id_ordem} excluída com sucesso! ${response.total_excluido} registros removidos.`,
            'success'
          )
          
          // Limpar formulário
          this.limparTudo()
          this.showConfirmDialog = false
          
          // Atualizar histórico
          this.buscarHistorico()
          
          // Voltar para aba de histórico
          this.activeTab = 'historico'
        } else {
          throw new Error(response.message || 'Erro na exclusão')
        }
      } catch (error) {
        console.error('Erro ao excluir ordem:', error)
        this.mostrarNotificacao(error.message || 'Erro ao excluir ordem', 'error')
      } finally {
        this.excluindoOrdem = false
      }
    },
    
    async buscarHistorico() {
      this.carregandoHistorico = true
      
      try {
        const response = await producaoService.listarLogExclusoes(this.filtrosHistorico)
        
        if (response.status === 'sucesso') {
          this.logsExclusao = response.logs
          this.totalLogsExclusao = response.pagination.total
        } else {
          throw new Error(response.message || 'Erro ao buscar histórico')
        }
      } catch (error) {
        console.error('Erro ao buscar histórico:', error)
        this.mostrarNotificacao('Erro ao carregar histórico', 'error')
        this.logsExclusao = []
        this.totalLogsExclusao = 0
      } finally {
        this.carregandoHistorico = false
      }
    },
    
    // ========================================
    // MÉTODOS AUXILIARES
    // ========================================
    
    limparDetalhes() {
      if (!this.buscaOrdemId) {
        this.detalhesOrdem = null
        this.observacaoExclusao = ''
      }
    },
    
    limparTudo() {
      this.buscaOrdemId = ''
      this.detalhesOrdem = null
      this.observacaoExclusao = ''
      this.confirmacaoTexto = ''
    },
    
    verDetalhesExclusao(item) {
      this.exclusaoSelecionada = item
      this.showDetalhesDialog = true
    },
    
    // ✅ MÉTODOS DE FORMATAÇÃO SEGUROS
    formatarObservacao(observacao) {
      try {
        if (!observacao) return 'Nenhuma observação disponível'
        
        if (typeof observacao === 'string') {
          if (observacao.startsWith('{') || observacao.startsWith('[')) {
            try {
              return JSON.stringify(JSON.parse(observacao), null, 2)
            } catch {
              return observacao
            }
          }
          return observacao
        }
        
        if (typeof observacao === 'object' && observacao !== null) {
          return JSON.stringify(observacao, null, 2)
        }
        
        return String(observacao)
        
      } catch (error) {
        console.warn('Erro ao formatar observação:', error)
        return 'Erro ao exibir observação'
      }
    },

    formatarDadosCompletos(dadosCompletos) {
      try {
        if (!dadosCompletos) return 'Nenhum dado disponível'
        
        if (typeof dadosCompletos === 'string') {
          try {
            return JSON.stringify(JSON.parse(dadosCompletos), null, 2)
          } catch {
            return dadosCompletos
          }
        }
        
        if (typeof dadosCompletos === 'object' && dadosCompletos !== null) {
          return JSON.stringify(dadosCompletos, null, 2)
        }
        
        return String(dadosCompletos)
        
      } catch (error) {
        console.warn('Erro ao formatar dados completos:', error)
        return 'Erro ao exibir dados completos'
      }
    },
    
    mostrarNotificacao(message, color = 'success') {
      this.snackbarMessage = message
      this.snackbarColor = color
      this.showSnackbar = true
    },
    
    formatarData(data) {
      if (!data) return 'N/A'
      return new Date(data).toLocaleDateString('pt-BR')
    },
    
    formatarDataHora(data) {
      if (!data) return 'N/A'
      return new Date(data).toLocaleString('pt-BR')
    },
    
    calcularTotalRegistros(registrosJson) {
      if (!registrosJson) return 0
      
      try {
        const registros = typeof registrosJson === 'string' 
          ? JSON.parse(registrosJson) 
          : registrosJson
        
        return Object.values(registros).reduce((total, count) => total + count, 0) + 1
      } catch (error) {
        return 0
      }
    },
    
    truncarTexto(texto, limite) {
      if (!texto) return ''
      return texto.length > limite ? texto.substring(0, limite) + '...' : texto
    }
  }
}
</script>

<style scoped>
/* ========================================
   ✅ SOLUÇÃO PRINCIPAL - SCROLL VERTICAL
======================================== */
.container-with-scroll {
  height: 100vh;
  overflow-y: auto;
  padding: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.exclusao-ordens-container {
  width: 100%;
  padding-bottom: 32px; /* Espaço extra no final */
}

/* ========================================
   LAYOUT PRINCIPAL
======================================== */
.page-header {
  margin-bottom: 24px;
}

.main-card {
  border-radius: 12px;
  overflow: visible;
}

.tabs-header {
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
}

.tab-item {
  font-weight: 600;
  text-transform: none;
}

.tabs-content {
  width: 100%;
}

/* ========================================
   ✅ BOTÕES DE AÇÃO - SEMPRE VISÍVEIS
======================================== */
.acoes-section {
  margin-bottom: 48px; /* Espaço generoso no final */
}

.acoes-card {
  border-radius: 8px;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border: 2px solid #e0e0e0;
}

.action-btn {
  min-width: 160px;
  height: 48px;
  font-weight: 600;
  text-transform: none;
}

.excluir-btn {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3);
  transition: all 0.3s ease;
}

.excluir-btn:hover {
  box-shadow: 0 6px 16px rgba(244, 67, 54, 0.4);
  transform: translateY(-2px);
}

/* ========================================
   CARDS E COMPONENTES
======================================== */
.search-card,
.detalhes-card,
.registros-card,
.observacao-card,
.filtros-card {
  border-radius: 8px;
}

.registro-item {
  transition: all 0.3s ease;
}

.registro-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.info-item {
  border-left: 3px solid #e0e0e0;
  padding-left: 12px;
}

.empty-state {
  color: #666;
}

/* ========================================
   TABELA E HISTÓRICO
======================================== */
.historico-table {
  border-radius: 8px;
  overflow-x: auto;
}

.observacao-cell {
  max-width: 200px;
  cursor: help;
}

.detail-item {
  border-left: 3px solid #2196f3;
  padding-left: 12px;
}

/* ========================================
   MODAIS E SCROLL
======================================== */
.detalhes-modal {
  max-height: 90vh;
  overflow-y: auto;
}

.scrollable-content {
  max-height: 300px;
  overflow-y: auto;
}

.scrollable-content .v-card-text {
  overflow-y: auto;
  word-wrap: break-word;
}

.formatted-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-family: 'Roboto Mono', monospace;
  font-size: 0.875rem;
  line-height: 1.4;
}

/* ========================================
   GARANTIR SCROLL EM MODAIS
======================================== */
.v-dialog .v-card {
  max-height: 90vh;
  overflow-y: auto;
}

/* ========================================
   QUEBRA DE LINHA
======================================== */
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* ========================================
   ✅ RESPONSIVIDADE MELHORADA
======================================== */
@media (max-width: 768px) {
  .container-with-scroll {
    padding: 12px;
  }
  
  .page-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }
  
  .action-btn {
    min-width: 140px;
    width: 100%;
    margin-bottom: 12px;
  }
  
  .d-flex.gap-4 {
    flex-direction: column;
    gap: 12px !important;
  }
  
  .acoes-section {
    margin-bottom: 32px;
  }
  
  .v-dialog {
    margin: 16px;
  }
  
  .v-dialog .v-card {
    max-height: calc(100vh - 32px);
  }
  
  .scrollable-content {
    max-height: 200px;
  }
}

@media (max-width: 480px) {
  .container-with-scroll {
    padding: 8px;
  }
  
  .action-btn {
    min-width: 120px;
    height: 44px;
  }
  
  .acoes-section {
    margin-bottom: 24px;
  }
}

/* ========================================
   ANIMAÇÕES
======================================== */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.detalhes-section {
  animation: slideInUp 0.3s ease;
}

/* ========================================
   ESTADOS DE HOVER
======================================== */
.search-card:hover,
.detalhes-card:hover,
.registros-card:hover,
.observacao-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

/* ========================================
   MELHORIAS DE ACESSIBILIDADE
======================================== */
.v-btn:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.v-text-field:focus-within {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* ========================================
   OTIMIZAÇÕES DE PERFORMANCE
======================================== */
.registro-item,
.search-card,
.detalhes-card,
.registros-card,
.observacao-card,
.excluir-btn {
  will-change: transform, box-shadow;
}

/* ========================================
   ✅ GARANTIAS EXTRAS PARA SCROLL
======================================== */
.tabs-content .v-window-item {
  min-height: auto;
  padding-bottom: 32px;
}

.historico-section,
.exclusao-section {
  padding-bottom: 24px;
}

/* Força o scroll quando necessário */
body {
  overflow-x: hidden;
}

.v-application {
  overflow-y: auto;
}
</style>
